
import { defineComponent, ref, reactive, computed } from "vue";
import Camera from "simple-vue-camera";
import Compressor from "compressorjs";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";
//import { useRoute } from "vue-router";
export default defineComponent({
  name: "picturesData",
  components: {
    Camera,
  },
  emits: ["saveImage"],
  setup(props, { emit }) {
    const id = ref(0);
    const camera = ref<InstanceType<typeof Camera>>();
    const devicesList = ref<any>([]);
    const deviceSelected = ref<string>("");
    //const route = useRoute();
    const cameraFrontal = ref(false);
    const state: any = reactive({
      formData: {
        picture: "",
        nameFile: "",
      },
    });
    const chooseDevice = (device: string) => {
      camera.value?.changeCamera(device);
    };
    const with_camera = ref<boolean>(true);
    const isOpenClose = ref<boolean>(false);
    const showModal = async (dialog: boolean, id_value: number) => {
      isOpenClose.value = dialog;
      id.value = id_value;
      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const res = devices.some((arrVal) => arrVal.kind === "videoinput");
        res ? (with_camera.value = true) : (with_camera.value = false);
      }
    };
    const OpenCloseModal = () => {
      isOpenClose.value = false;
      state.formData.picture = "";
      v$.value.$reset();
      devicesList.value = [];
    };
    const uploadResolution = (val) => {
      document.getElementById(val)?.click();
    };
    const onFileChange = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      new Compressor(files[0], {
        quality: 0.6,
        convertSize: 5000000,
        success(result) {
          createImage(result);
        },
      });
    };
    const createImage = (file: any) => {
      let img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = () => {
        if (img.width <= 500 && img.height <= 500) {
          //alert(`Nice, image is the right size. It can be uploaded`);
          state.formData.picture = new Image();
          var reader = new FileReader();
          reader.onload = (e) => {
            state.formData.picture = e.target?.result;
          };
          reader.readAsDataURL(file);
        } else {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = 500; // Set the desired width
          canvas.height = 500; // Set the desired height
          ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
          state.formData.picture = canvas.toDataURL(file.type);
          state.formData.nameFile = file.name;
        }
        //img.src = URL.createObjectURL(file);
      };
    };
    const openCamera = () => {
      cameraFrontal.value = !cameraFrontal.value;
      setTimeout(async () => {
        devicesList.value = await camera.value?.devices(["videoinput"]);
      }, 100);
    };
    const snapshot = async () => {
      const blob = await camera.value?.snapshot();
      // To show the screenshot with an image tag, create a url
      //   const url = URL.createObjectURL(blob);
      //   console.log(url);
      const res = await convertBlobToBase64(blob);
      state.formData.picture = res as string;
    };
    const convertBlobToBase64 = async (blob) => {
      // blob data
      return await blobToBase64(blob);
    };
    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    const deletesnapshot = () => {
      state.formData.picture = "";
      v$.value.$reset();
    };
    const saveImage = async () => {
      const isFormCorrect = await v$.value.$validate();
      if (!isFormCorrect) return;
      emit("saveImage", { formData: state.formData, id: id.value });
      isOpenClose.value = false;
      state.formData.picture = "";
      v$.value.$reset();
    };
    const rotateImage = async () => {
      const img = new Image();
      img.src = state.formData.picture;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const { width, height } = img;

        // Set canvas dimensions based on image dimensions
        canvas.width = height;
        canvas.height = width;

        // Rotate image 90 degrees
        ctx?.translate(canvas.width / 2, canvas.height / 2);
        ctx?.rotate((90 * Math.PI) / 180);
        ctx?.drawImage(img, -width / 2, -height / 2);

        // Convert rotated image back to base64 format
        return (state.formData.picture = canvas.toDataURL());
      };
    };
    const rules = computed(() => {
      return {
        formData: {
          picture: {
            required: requiredIf(function () {
              return id.value !== 0;
            }),
          },
        },
      };
    });
    const v$ = useVuelidate(rules, state);
    return {
      id,
      cameraFrontal,
      state,
      openCamera,
      camera,
      snapshot,
      deletesnapshot,
      onFileChange,
      createImage,
      showModal,
      isOpenClose,
      OpenCloseModal,
      uploadResolution,
      devicesList,
      deviceSelected,
      chooseDevice,
      with_camera,
      saveImage,
      rotateImage,
      v$,
    };
  },
});
